var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 3.90749C0.0625 6.05119 1.84323 7.80142 4.02427 7.80142H10.0014L8.26213 9.49738C7.91703 9.83657 7.91703 10.4064 8.26213 10.7456C8.60723 11.0848 9.187 11.0848 9.5321 10.7456L12.8037 7.53006C13.1488 7.19087 13.1488 6.62103 12.8037 6.28184L9.5321 3.0663C9.35265 2.88992 9.13179 2.80851 8.89712 2.80851C8.66245 2.80851 8.44158 2.88992 8.26213 3.0663C7.91703 3.40549 7.91703 3.97533 8.26213 4.31452L10.0014 6.02405H4.02427C2.83712 6.02405 1.85703 5.07431 1.85703 3.89393C1.85703 2.7271 2.82332 1.7638 4.02427 1.7638C4.52122 1.7638 4.92154 1.37034 4.92154 0.8819C4.92154 0.393463 4.52122 0 4.02427 0C1.84323 0.0135679 0.0625 1.75023 0.0625 3.90749Z",
    fill: "#B2C1F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.43361c9b6b5a10b1ee2c8ba08324dad8.svg";
export { ForwardRef as ReactComponent };